export default "__VITE_ASSET__DHaSNfCI__"